import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../api';

const HomeScreen = () => {
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    // Fetch User's Questions
    useEffect(() => {
        const fetchMyQuestions = async () => {
            try {
                const token = localStorage.getItem('token');
                // Use the new endpoint we just created
                const res = await axios.get(`${API_BASE_URL}/api/questions/my`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setQuestions(res.data);
                setLoading(false);
            } catch (err) {
                console.error("Failed to fetch questions", err);
                setLoading(false);
            }
        };

        if (user.role === 'MLA' || user.role === 'MLC') {
            fetchMyQuestions();
        } else {
            setLoading(false);
        }
    }, [user.role]);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/';
    };

    const StatusBadge = ({ status }) => {
        const colors = {
            'NEW': '#C0722C',
            'PENDING': '#F57C00',
            'ASSIGNED': '#1976D2',
            'ANSWERED': '#388E3C',
            'PUBLISHED': '#00796B', // Teal for Published
            'REJECTED': '#D32F2F'
        };
        return (
            <span style={{
                backgroundColor: colors[status] || '#999',
                color: 'white',
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '11px',
                fontWeight: '700',
                textTransform: 'uppercase'
            }}>
                {status}
            </span>
        );
    };

    return (
        <div style={{ backgroundColor: '#F3F0E7', minHeight: '100vh', fontFamily: '"Outfit", sans-serif' }}>
            {/* Header */}
            <header style={{
                backgroundColor: '#fff',
                padding: '15px 40px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                borderBottom: '1px solid #E0E0E0'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div style={{ width: '40px', height: '40px', backgroundColor: '#C0722C', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 'bold' }}>
                        BV
                    </div>
                    <div>
                        <h1 style={{ margin: 0, fontSize: '18px', color: '#2C1A10', fontWeight: '700' }}>Bihar Vidhan Sabha</h1>
                        <span style={{ fontSize: '12px', color: '#888' }}>Legislative Portal</span>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <div style={{ textAlign: 'right' }}>
                        <div style={{ fontWeight: '600', color: '#2C1A10', fontSize: '14px' }}>{user.firstName} {user.lastName}</div>
                        <div style={{ fontSize: '11px', color: '#666' }}>{user.designation} | {user.constituency || 'Nominated'}</div>
                    </div>
                    <button onClick={handleLogout} style={{
                        padding: '8px 16px', backgroundColor: '#F5F5F5', border: '1px solid #E0E0E0', borderRadius: '8px',
                        cursor: 'pointer', fontWeight: '600', color: '#666', fontSize: '13px'
                    }}>
                        Sign Out
                    </button>
                </div>
            </header>

            {/* Main Content */}
            <main style={{ maxWidth: '1200px', margin: '40px auto', padding: '0 20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                    <h2 style={{ fontSize: '28px', color: '#2C1A10', margin: 0 }}>My Legislative Dashboard</h2>
                    {/* Placeholder for new question action (future scope) */}
                    {/* <button style={{ backgroundColor: '#2C1A10', color: '#fff', padding: '12px 24px', borderRadius: '12px', border: 'none', fontWeight: '600', cursor: 'pointer' }}>+ Submit Question</button> */}
                </div>

                {loading ? (
                    <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Loading secure records...</div>
                ) : (
                    <div style={{ display: 'grid', gap: '25px' }}>
                        {questions.length === 0 ? (
                            <div style={{
                                backgroundColor: '#fff', padding: '60px', borderRadius: '24px', textAlign: 'center',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.03)'
                            }}>
                                <div style={{ fontSize: '48px', marginBottom: '15px' }}>📭</div>
                                <h3 style={{ color: '#2C1A10', margin: '0 0 10px 0' }}>No Active Inquiries</h3>
                                <p style={{ color: '#888', margin: 0 }}>You have not submitted any legislative questions for the current session.</p>
                            </div>
                        ) : (
                            questions.map(q => (
                                <div key={q._id} style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '20px',
                                    padding: '25px',
                                    boxShadow: '0 10px 30px rgba(0,0,0,0.03)',
                                    border: '1px solid #F0F0F0',
                                    transition: 'transform 0.2s',
                                    cursor: 'default'
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                                        <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                                            <StatusBadge status={q.status} />
                                            <span style={{ fontSize: '12px', color: '#888', fontWeight: '600' }}>Ref: {q._id.slice(-6).toUpperCase()}</span>
                                            <span style={{ fontSize: '12px', color: '#888' }}>•</span>
                                            <span style={{ fontSize: '12px', color: '#888' }}>{new Date(q.createdAt).toLocaleDateString()}</span>
                                        </div>
                                        <div style={{ fontSize: '13px', fontWeight: '700', color: '#444' }}>
                                            Ministry of {q.department}
                                        </div>
                                    </div>

                                    <h3 style={{ fontSize: '18px', color: '#2C1A10', margin: '0 0 12px 0', lineHeight: '1.4' }}>
                                        {q.subject}
                                    </h3>
                                    <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6', margin: '0 0 20px 0' }}>
                                        {q.questionText}
                                    </p>

                                    {/* Answer Section - Only visible if Published */}
                                    {q.status === 'PUBLISHED' && q.answerText ? (
                                        <div style={{
                                            backgroundColor: '#F1F8E9',
                                            borderRadius: '16px',
                                            padding: '20px',
                                            border: '1px solid #C5E1A5'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                                                <div style={{ width: '24px', height: '24px', backgroundColor: '#2E7D32', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '12px' }}>✓</div>
                                                <div style={{ fontSize: '12px', fontWeight: '800', color: '#2E7D32', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                                    Official Response
                                                </div>
                                            </div>
                                            <div style={{ fontSize: '15px', color: '#1B5E20', lineHeight: '1.6', whiteSpace: 'pre-line' }}>
                                                {q.answerText}
                                            </div>
                                            {q.answeredAt && (
                                                <div style={{ marginTop: '10px', fontSize: '11px', color: '#558B2F', textAlign: 'right', fontWeight: '600' }}>
                                                    Tabled on: {new Date(q.answeredAt).toLocaleDateString()}
                                                </div>
                                            )}
                                        </div>
                                    ) : q.status === 'ANSWERED' ? (
                                        <div style={{ padding: '15px', backgroundColor: '#E3F2FD', borderRadius: '12px', color: '#1565C0', fontSize: '13px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <span>ℹ️</span> Response received from Ministry. Awaiting Secretariat publication.
                                        </div>
                                    ) : (
                                        <div style={{ padding: '15px', backgroundColor: '#FAFAFA', borderRadius: '12px', color: '#888', fontSize: '13px', border: '1px solid #EEE' }}>
                                            Awaiting response functionality from the designated department.
                                        </div>
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                )}
            </main>
        </div>
    );
};

export default HomeScreen;
